module.exports = __webpack_public_path__ + "static/media/18ECA40.25ef3e1b.jpg";